import React, { useState, useEffect } from 'react';
import { Grid, Typography, Box } from '@mui/material';
import backgroundImage from '../assets/img/background.jpg';
import useStyles from '../styles/styles';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const Hero = props => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();

  return (
    <Box
      className={classes.heroBox}
      sx={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
      }}
      style={{ direction: isRTL === 'rtl' ? 'rtl' : 'ltr' }}
    >
      <Grid container spacing={12} className={classes.gridContainer}>
        <Grid item xs={12} >
          <Typography
            variant="h3"
            sx={{
              textAlign: 'center',
              color: '#fff',
              fontWeight: 'bold',
              textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)',
            }}
          >
            {'¡Ser amable paga!'}
          </Typography>          
        </Grid>


      </Grid>
    </Box>
  );
};

export default Hero;
